import { Stack, Text, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { useTranslation } from 'react-i18next'

import UserDetails from '@/components/Details/UserDetails/UserDetails'
import { useAuth } from '@/plugins/auth'

interface NominatedByProps {
  nominator: string
}

const NominatedBy: React.FC<NominatedByProps> = ({ nominator }) => {
  const { address } = useAuth()
  const theme = useMantineTheme()
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)

  return (
    <Stack
      style={{
        flexDirection: 'row',
        gap: '5px',
        alignItems: 'center',
        width: 'fit-content',
      }}
    >
      <Text style={{ textWrap: 'nowrap' }}>
        {t('components.governance.nomineeCard.nominatedBy', 'Nominated by:')}
      </Text>

      {!(nominator.toLowerCase() === address?.toLowerCase()) ? (
        <UserDetails
          hidePfp
          userId={nominator}
          hideCreatorName
          width={isMobile ? '80px' : '100px'}
        />
      ) : (
        <Text style={{ color: theme.colors.barChartYellow[0] }}>you</Text>
      )}
    </Stack>
  )
}
export default NominatedBy
